import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './registerServiceWorker'
import vuetify from '@/plugins/vuetify' // path to vuetify export
import AOS from 'aos';
import 'aos/dist/aos.css'; // You can also use <link> for styles
import Datepicker from 'vuejs-datepicker';
import axios from 'axios'
import emailjs from 'emailjs-com';
import{ init } from 'emailjs-com';

// emailjs
init("user_pM3krz39kIuEpdxINLKpM");
window.emailjs = emailjs

// axios as window variable
window.db = axios

// aos transitions
AOS.init();

Vue.config.productionTip = false
Vue.component("vuejs-datepicker", Datepicker)

new Vue({
  vuetify,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
